/* Recipe hub + spirit/genre landing pages: render cards from the prebuilt
   recipes-index.json (generated by scripts/build_recipe_index.py). Liquid's
   metaobjects.recipe.values caps around ~50 entries, so the theme never loops
   recipes server-side — both sections fetch the index and render client-side.

   Hub root:      [data-recipe-hub]  with data-index-url, data-page-size
   Taxonomy root: [data-recipe-tax]  with data-index-url, data-page-size,
                  data-dim ("spirit"|"genre"), data-handle (current entry) */
(function () {
  'use strict';

  function sized(url, w) {
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function shortLabel(labels, slug) {
    var name = labels[slug] || slug.replace(/-/g, ' ').replace(/\b\w/g, function (c) { return c.toUpperCase(); });
    var short = name.replace(/\s*\d+\s*ml\b/i, '').replace(/\s+cocktail\s+syrup\b/i, '').trim();
    // drop a bare trailing "Syrup" too, but never down to one word ("Simple Syrup" stays)
    if (/\S+\s+\S+\s+syrup$/i.test(short)) short = short.replace(/\s+syrup$/i, '');
    return short || name;
  }

  var URL_BASE = '/pages/recipes/'; // overwritten by index.base once the index loads

  function makeCard(r, labels, prefix) {
    var a = document.createElement('a');
    a.className = prefix + '__card';
    a.href = URL_BASE + r.handle;
    if (r.image) {
      var img = document.createElement('img');
      img.className = prefix + '__thumb';
      img.loading = 'lazy';
      img.alt = r.title;
      img.src = sized(r.image, 480);
      img.srcset = sized(r.image, 240) + ' 240w, ' + sized(r.image, 480) + ' 480w, ' + sized(r.image, 720) + ' 720w';
      img.sizes = '(min-width: 990px) 25vw, 50vw';
      a.appendChild(img);
    } else {
      var ph = document.createElement('div');
      ph.className = prefix + '__thumb';
      a.appendChild(ph);
    }
    var h = document.createElement('h3');
    h.textContent = r.title;
    a.appendChild(h);
    var names = r.spirit.concat(r.genre).map(function (s) { return labels[s] || s; });
    if (names.length) {
      var p = document.createElement('p');
      p.className = prefix + '__card-tags';
      p.textContent = names.join(' · ');
      a.appendChild(p);
    }
    return a;
  }

  /* Renders `matched` into `grid` in batches; wires the Load-more button.
     `endEl` is the "that's everything" note that replaces the button once the
     last batch lands — without it the button just vanishes and the visitor has
     no signal that they hit the end of the results rather than a broken button.
     The note only appears when paging actually happened (more than one batch);
     under a single short result set the count line above the grid already says
     everything there is to say. */
  function pager(grid, moreBtn, labels, prefix, pageSize, endEl) {
    var matched = [], shown = 0;
    function renderNext(fromClick) {
      var frag = document.createDocumentFragment();
      matched.slice(shown, shown + pageSize).forEach(function (r) {
        frag.appendChild(makeCard(r, labels, prefix));
      });
      grid.appendChild(frag);
      shown = Math.min(shown + pageSize, matched.length);
      var done = shown >= matched.length;
      if (moreBtn) moreBtn.hidden = done;
      if (endEl) {
        endEl.hidden = !(done && matched.length > pageSize);
        // The button the visitor just clicked is gone; move focus to the note so
        // keyboard + screen-reader users aren't dumped back at the top of the page.
        // Only for keyboard-driven clicks — handing a mouse user focus just paints
        // a focus ring around the note for no reason, and they lose nothing by
        // staying where they are.
        if (fromClick === 'keyboard' && !endEl.hidden) endEl.focus();
      }
    }
    if (moreBtn) moreBtn.addEventListener('click', function () {
      // :focus-visible on the button is the browser's own read of "this visitor is
      // driving with the keyboard" — reuse it rather than tracking input modality.
      var kbd = false;
      try { kbd = moreBtn.matches(':focus-visible'); } catch (e) { kbd = false; }
      renderNext(kbd ? 'keyboard' : 'pointer');
    });
    return function reset(list) {
      matched = list;
      shown = 0;
      grid.textContent = '';
      renderNext(null);
    };
  }

  function loadIndex(root, cb) {
    fetch(root.dataset.indexUrl)
      .then(function (res) {
        if (!res.ok) throw new Error('recipes-index.json HTTP ' + res.status);
        return res.json();
      })
      .then(function (index) {
        if (index.base) URL_BASE = index.base;
        cb(index);
      })
      .catch(function (err) { console.error('[recipe-hub]', err); });
  }

  // ---------------------------------------------------------------- hub
  var hub = document.querySelector('[data-recipe-hub]');
  if (hub) {
    /* Pin the filter bar flush under the header's REAL bottom edge — the static
       --header-height token drifts from the rendered header (it pins at -1px,
       and device rendering varies), which left a see-through gap on mobile. */
    (function trackHeaderBottom() {
      var headerEl = document.querySelector('.header-section, header-component, header');
      if (!headerEl) return;
      var last = null, queued = false;
      function measure() {
        queued = false;
        var b = Math.max(0, Math.round(headerEl.getBoundingClientRect().bottom));
        if (b !== last) { last = b; hub.style.setProperty('--hub-sticky-top', b + 'px'); }
      }
      function queue() { if (!queued) { queued = true; window.requestAnimationFrame(measure); } }
      window.addEventListener('scroll', queue, { passive: true });
      window.addEventListener('resize', queue);
      measure();
    })();
    // mobile "Filter" dropdown — works pre-index-load; CSS keeps the panel
    // always open ≥990px regardless of this state
    var toggleBtn = hub.querySelector('[data-hub-toggle]');
    var panelEl = hub.querySelector('[data-hub-filters]');
    if (toggleBtn && panelEl) {
      toggleBtn.addEventListener('click', function () {
        var open = panelEl.classList.toggle('is-open');
        toggleBtn.setAttribute('aria-expanded', String(open));
      });
    }

    loadIndex(hub, function (index) {
      var recipes = index.recipes, labels = index.labels;
      var searchEl = hub.querySelector('[data-hub-search]');
      var countEl = hub.querySelector('[data-hub-count]');
      var emptyEl = hub.querySelector('[data-hub-empty]');
      var activeEl = hub.querySelector('[data-hub-active]');
      var badgeEl = hub.querySelector('[data-hub-badge]');
      var render = pager(hub.querySelector('[data-hub-grid]'), hub.querySelector('[data-hub-more]'),
        labels, 'hub', parseInt(hub.dataset.pageSize, 10) || 48, hub.querySelector('[data-hub-end]'));

      // Syrup leads (owner call) — it's the group shoppers filter by most
      var GROUPS = [['syrup', 'Syrup'], ['spirit', 'Spirit'], ['genre', 'Genre'], ['extras', 'Extras']];
      var active = { spirit: new Set(), genre: new Set(), syrup: new Set(), extras: new Set() };
      var chipRefs = {}; // "key|value" -> facet chip button, for syncing removals

      function facetLabel(key, v) {
        return key === 'extras' ? v : shortLabel(labels, v);
      }

      function setFacet(key, v, on) {
        active[key][on ? 'add' : 'delete'](v);
        var chip = chipRefs[key + '|' + v];
        if (chip) chip.setAttribute('aria-pressed', String(on));
      }

      var firstGroup = true;
      GROUPS.forEach(function (g) {
        var key = g[0], values = new Set();
        recipes.forEach(function (r) { r[key].forEach(function (v) { values.add(v); }); });
        if (!values.size) return;

        var group = document.createElement('div');
        group.className = 'hub__group';
        var open = firstGroup; // leading group (Syrup) starts open, rest collapsed
        firstGroup = false;

        var btn = document.createElement('button');
        btn.className = 'hub__group-btn';
        btn.type = 'button';
        btn.textContent = g[1];
        btn.setAttribute('aria-expanded', String(open));
        btn.setAttribute('aria-controls', 'hub-group-' + key);
        group.appendChild(btn);

        var panel = document.createElement('div');
        panel.className = 'hub__group-panel';
        panel.id = 'hub-group-' + key;
        panel.hidden = !open;
        btn.addEventListener('click', function () {
          panel.hidden = !panel.hidden;
          btn.setAttribute('aria-expanded', String(!panel.hidden));
        });

        Array.from(values).sort().forEach(function (v) {
          var b = document.createElement('button');
          b.className = 'hub__chip';
          b.type = 'button';
          b.setAttribute('aria-pressed', 'false');
          b.textContent = facetLabel(key, v);
          b.addEventListener('click', function () {
            setFacet(key, v, !active[key].has(v));
            apply();
          });
          chipRefs[key + '|' + v] = b;
          panel.appendChild(b);
        });
        group.appendChild(panel);
        panelEl.appendChild(group);
      });

      /* Active facets as removable chips — stay visible (sticky bar on mobile,
         top of the sidebar on desktop) so applied filters are always in view. */
      function renderActive() {
        activeEl.textContent = '';
        var total = 0;
        GROUPS.forEach(function (g) {
          var key = g[0];
          active[key].forEach(function (v) {
            total++;
            var chip = document.createElement('button');
            chip.className = 'hub__active-chip';
            chip.type = 'button';
            chip.textContent = facetLabel(key, v);
            chip.setAttribute('aria-label',
              (activeEl.dataset.removeLabel || 'Remove filter') + ': ' + facetLabel(key, v));
            chip.addEventListener('click', function () {
              setFacet(key, v, false);
              apply();
            });
            activeEl.appendChild(chip);
          });
        });
        if (total) {
          var clear = document.createElement('button');
          clear.className = 'hub__clear';
          clear.type = 'button';
          clear.textContent = activeEl.dataset.clearLabel || 'Clear all';
          clear.addEventListener('click', function () {
            GROUPS.forEach(function (g) {
              Array.from(active[g[0]]).forEach(function (v) { setFacet(g[0], v, false); });
            });
            apply();
          });
          activeEl.appendChild(clear);
        }
        activeEl.hidden = !total;
        if (badgeEl) badgeEl.textContent = total ? ' (' + total + ')' : '';
      }

      function apply() {
        var q = (searchEl.value || '').trim().toLowerCase();
        var matched = recipes.filter(function (r) {
          var ok = GROUPS.every(function (g) {
            var key = g[0];
            if (!active[key].size) return true;
            return r[key].some(function (v) { return active[key].has(v); });
          });
          return ok && (!q || r.title.toLowerCase().indexOf(q) > -1);
        });
        countEl.textContent = matched.length + ' recipe' + (matched.length === 1 ? '' : 's');
        emptyEl.hidden = matched.length !== 0;
        renderActive();
        render(matched);
      }
      searchEl.addEventListener('input', apply);

      // Deep-link: pre-apply facets from the URL, e.g. a product card's
      // "Recipes" link → /pages/recipes-hub?syrup=<product-handle>. Only real
      // facet values (present in chipRefs) are applied, so an unknown handle
      // just shows everything instead of an empty grid.
      try {
        var params = new URLSearchParams(window.location.search);
        GROUPS.forEach(function (g) {
          var key = g[0];
          params.getAll(key).forEach(function (chunk) {
            chunk.split(',').forEach(function (v) {
              v = v.trim();
              if (v && chipRefs[key + '|' + v]) setFacet(key, v, true);
            });
          });
        });
      } catch (e) {
        /* no URLSearchParams / bad query — fall back to no filters */
      }

      apply();
    });
  }

  // ---------------------------------------------------------------- related rail (recipe page)
  var rel = document.querySelector('[data-recipe-related]');
  if (rel) {
    loadIndex(rel, function (index) {
      var handle = rel.dataset.handle;
      var mine = {
        syrup: (rel.dataset.syrups || '').split(/\s+/).filter(Boolean),
        spirit: (rel.dataset.spirit || '').split(/\s+/).filter(Boolean),
        genre: (rel.dataset.genre || '').split(/\s+/).filter(Boolean)
      };
      // shared syrup is the strongest signal, then spirit, then genre
      var scored = index.recipes
        .filter(function (r) { return r.handle !== handle; })
        .map(function (r) {
          var s = 0;
          r.syrup.forEach(function (x) { if (mine.syrup.indexOf(x) > -1) s += 3; });
          r.spirit.forEach(function (x) { if (mine.spirit.indexOf(x) > -1) s += 2; });
          r.genre.forEach(function (x) { if (mine.genre.indexOf(x) > -1) s += 1; });
          return { r: r, s: s };
        })
        .filter(function (x) { return x.s > 0; })
        .sort(function (a, b) { return b.s - a.s; });
      if (!scored.length) return; // rail stays hidden
      var grid = rel.querySelector('[data-related-grid]');
      var n = parseInt(rel.dataset.count, 10) || 4;
      scored.slice(0, n).forEach(function (x) {
        grid.appendChild(makeCard(x.r, index.labels, 'rel'));
      });
      rel.hidden = false;
    });
  }

  // ---------------------------------------------------------------- taxonomy landing
  var tax = document.querySelector('[data-recipe-tax]');
  if (tax) {
    loadIndex(tax, function (index) {
      var dim = tax.dataset.dim, handle = tax.dataset.handle;
      var matched = index.recipes.filter(function (r) { return r[dim].indexOf(handle) > -1; });
      var emptyEl = tax.querySelector('[data-tax-empty]');
      if (emptyEl) emptyEl.hidden = matched.length !== 0;
      pager(tax.querySelector('[data-tax-grid]'), tax.querySelector('[data-tax-more]'),
        index.labels, 'tax', parseInt(tax.dataset.pageSize, 10) || 48,
        tax.querySelector('[data-tax-end]'))(matched);
    });
  }
})();
